import { DateTime } from 'luxon';
import { createSelector } from 'reselect';
import { RootState } from '@/models/root-state.model';
import { utcToLocalTime } from '@/utils/utils';
import { BffLoginHistory } from '@lucky7ventures/bff-types';

export const selectLoginHistory = (state: RootState): BffLoginHistory[] =>
  state.loginHistory.loginHistory;
export const selectLoginHistoryLoading = (state: RootState): boolean => state.loginHistory.loading;

export const selectCurrentLogin = createSelector(selectLoginHistory, loginHistory =>
  loginHistory.length > 0 ? utcToLocalTime(new Date(loginHistory[0].dateCreated)) : null,
);

export const selectLastLogin = createSelector(selectLoginHistory, loginHistory => {
  if (loginHistory.length < 2) {
    return null;
  }

  const date = utcToLocalTime(new Date(loginHistory[1].dateCreated));
  const lastLogin = DateTime.fromJSDate(date)
    .setLocale('sv-se')
    .toLocaleString(DateTime.DATETIME_FULL);

  return lastLogin;
});
